// Original PDF of a grid code version (S3): typed page, zoom and requirement search params (page 1 stripped from the URL), the breadcrumb, and the full-height viewer screen; page turns replace the history entry.
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod";

import { numberWithDefault, optionalNumber, optionalString } from "@/app/search";
import { OriginalPdfScreen } from "@/features/source/OriginalPdfScreen";

const searchSchema = z.object({
  page: numberWithDefault(1, 1, 100000),
  zoom: optionalNumber(0.25, 4),
  req: optionalString(),
});

const searchDefaults = { page: 1 } satisfies Partial<z.output<typeof searchSchema>>;

export const Route = createFileRoute("/_app/$region/library/$docUid_/pdf")({
  validateSearch: searchSchema,
  search: { middlewares: [stripSearchParams(searchDefaults)] },
  staticData: { crumb: "PDF" },
  component: OriginalPdfRoute,
});

function OriginalPdfRoute() {
  const { region, docUid } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <OriginalPdfScreen
      region={region}
      docUid={docUid}
      search={search}
      onSearchChange={(patch) => {
        void navigate({ search: (previous) => ({ ...previous, ...patch }), replace: true });
      }}
    />
  );
}
